// extracted by mini-css-extract-plugin
export var createdDate = "_lf-1";
export var divider = "_lf-2";
export var headerDivider = "_lf-3";
export var messagesCard = "_lf-0";
export var messagesContainer = "_lf-6";
export var messagesContainerWrapper = "_lf-4";
export var showLeftPanelButton = "_lf-8";
export var topButtons = "_lf-7";
export var withPadding = "_lf-5";